import '@/scss/styles.scss'

import Vue from 'vue'
import VueResource from 'vue-resource'

import Element from 'element-ui'
import elementLocale from 'element-ui/lib/locale/lang/ru-RU';
import moment from 'moment';

import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'

Vue.use(Element, { locale: elementLocale })
Vue.use(VueResource)

Vue.prototype.$moment = moment;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
